<template>
  <div>
    <selectors
       prefix="filter"
      :modal="modal"
      :selectKey="titleKey"
      v-model="val"
      :title="title"
      :params="params"
      @input="input"
    />
  </div>
</template>
<script>
export default {
  props: {
    modal: {
      default: "",
    },
    title: {
      default: "",
    },
    nojoin: {
      default: false,
    },
    titleKey:{
      default:'title'
    },
    params:{
      default:function(){
        return {};
      }
    },
  },
  name: "filter",
  components: {
    selectors: () => import("./Inputs/Selectors"),
  },
  methods: {
    input() {
      let value = [];
      for (let i = 0; i < this.val.length; i++) {
        value.push(this.val[i].id);
      }

      this.$emit("input", this.nojoin ? value : value.join("-"));
    },
  },
  data() {
    return {
      val: [],
    };
  },
};
</script>
<style>
</style>
